import * as React from 'react';

import { IFotoramaData } from '../../../../typings/fotorama';
import { INeighbourhoodSchema } from '../../../types';
import { PopupGallery } from '../popup_gallery';
import { IImageComment } from '../popup_gallery/comment';

export interface IMobileFullScreenGalleryStateProps {
  slides: IFotoramaData[];
  neighbourhoodList: INeighbourhoodSchema[];
}

interface IMobileFullScreenGalleryOwnProps {
  startWithSlide?: number;
  startFromNeighbourhood?: boolean;
  onClose(): void;
  slideDidChange?(slideIndex: number): void;
}

type TMainFullScreenGallery = IMobileFullScreenGalleryStateProps & IMobileFullScreenGalleryOwnProps;

export function MobileFullScreenGallery(props: TMainFullScreenGallery) {
  const { onClose, slideDidChange, neighbourhoodList, slides, startWithSlide, startFromNeighbourhood } = props;

  const gallerySlides: IFotoramaData[] = [
    ...slides,
    ...neighbourhoodList.map(({ imageUrl, thumbnailUrl }) => ({ img: imageUrl, thumb: thumbnailUrl })),
  ];
  const tabs = [
    {
      title: 'Коттеджный посёлок',
      startIndex: 0,
    },
  ];

  const comments: (IImageComment | null)[] = new Array(slides.length).fill(null);

  if (neighbourhoodList.length) {
    tabs.push({
      title: 'Окрестности',
      startIndex: slides.length || 0,
    });
    comments.push(...neighbourhoodList.map(({ description = '' }) => ({ comment: description })));
  }

  return (
    <PopupGallery
      slides={gallerySlides}
      comments={comments}
      onClose={onClose}
      tabs={tabs}
      startWithSlide={startFromNeighbourhood ? (startWithSlide || 0) + slides.length : startWithSlide}
      slideDidChange={slideDidChange}
    />
  );
}
